export default {
  deposit: 'Deposit BBG',
  withdraw: 'Withdraw BBG',
  available: 'Available in-game BBG: {{amount}}',
  onChain: 'World App BBG: {{amount}}',
  wldFee: 'Withdrawal fee: 0.05 WLD (World App)',
  amount: 'Amount',
  confirm: 'Confirm',
  cancel: 'Cancel',
  unfreeze: 'Unfreeze',
  max: 'Max',
  inputHint: 'This transaction is completed in Bubble Wallet.',
  worldAppOnly: 'Open Bubble Wallet in World App to complete this transaction.',
  processing: 'Processing…',
  depositTransactionTitle: 'Depositing BBG…',
  depositTransactionDescription: 'Sending {{amount}} BBG to the Bubble Game vault in World App.',
  payingWldTitle: 'Paying WLD…',
  payingWldDescription: 'Sending 0.05 WLD to World App as the BBG withdrawal fee.',
  preparing: 'Preparing transaction…',
  success: 'Transaction completed.',
  successTitle: 'BBG deposit successful',
  successDescription: 'BBG has been credited to your in-game wallet.',
  withdrawalSuccessTitle: 'BBG withdrawal successful',
  withdrawalSuccessDescription: 'BBG has been sent to your World App wallet.',
  successAmount: 'Amount',
  successChainId: 'Chain ID',
  successTxHash: 'Transaction Hash',
  successCreditedAt: 'Credited at',
  viewOnWorldscan: 'View Transaction Hash on Worldscan',
  withdrawalViewOnWorldscan: 'View Transaction Hash on Worldscan',
  done: 'Done',
  failed: 'Transaction failed.',
  pending: 'Withdrawal is being processed.',
  finalizePending: 'BBG is on-chain; ledger synchronization is pending. Do not pay the fee again.',
  pendingNoDuplicate: 'Do not pay the fee again; return to Overview to check the status.',
  pendingStatusUnavailable: 'Unable to confirm the on-chain status. Sign in again and try later.',
  noBalance: 'No available balance.',
} as const;
